/**
 * @file 首页
 * @author wangzhuang
 */

import {
    GET_PAID_ATTEST_LIST
} from '../actions/ActionTypes';
const initialState = {
    paidAttestList: {}
};
export function myAttestReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PAID_ATTEST_LIST:
            return {
                ...state,
                paidAttestList: action.data?.data || {}
            };
        default:
            return state;
    }
}